import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-modal";
import {
  certificateHolderModalOpened,
  getCertificateHolderModalState,
  certificateModalClosed,
  getBinderLetterFromURL,
  getBinderLetterStatus,
  gettingBinderLetterPDFSuccess,
} from "../../store/components";
import Select from "react-dropdown-select";
import { additionalModalOpened } from "../../store/components";
import { emailBodyCertificate } from "../../helper/constants";
import LoadingSpinner from "../BinderLoading";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CancelIcon from "@material-ui/icons/Cancel";
import * as theme from "../../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { getCoverIdForExpiryDate } from "../../store/businesslogic/hardwiredlogic";
import {
  allCertificateDetails,
  certificateFalg,
  downloadCertificate,
  getLocationObjectValue,
  locationObjForEditCopy,
} from "../../store/certificate";
import moment from "moment";
import ReactLoading from "react-loading";
import {
  getSingleCertificateList,
  certificateDataClear,
  getDownloadedCertificate,
} from "../../store/certificate";
import {
  getBinderDetails,
  getEncryCRSProspectIdFromMyBinders,
  getSelectedBinderDetails,
  getSelectedBinderDetailLocationAddress,
  getCurrentClientDetails,
} from "../../store/mybinder";
import {
  allCertificateHolderList,
  getCertificateHolderListDetails,
} from "../../store/certificate";
import AddCertificateHolder from "../AddCertificateHolder";
import { ImportantDevices, LabelImportant } from "@material-ui/icons";
import {
  addResponseSeqToCols,
  PossibleApiStatusValues,
  processCoversData,
} from "../../store/helperfuncs";
import SelectedCertificateCoverByCoverType from "./SelectedCertificateCoverByCoverType";
import { isDecimal } from "../../utils/utils";
import { getBrokerInformation } from "../../store/broker";
import _ from "lodash";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import PdfSettingsModal from "../PdfSettingsModal";
import externalTranslations from "../../utils/translations";

const translations = {
  en: {
    certificate: {
      customizeCertificateHeading: "Customize your Certificate",
      customizeCertificateSubHeading:
        "From here, you can customize the details of your certificate.",
      clientInformation: "Client Information",
      clientName: "Client Name",
      addressLine1: "Address Line 1",
      addressLine2: "Address Line 2",
      townCity: "Town/City",
      province: "Province",
      postalCode: "PostalCode",
      country: "Country",
      descriptionOfOperations:
        "Description of operations, locations or special conditions",
      certificateHolderInformation: "Certificate Holder Information",
      addNew: "Add New",
      selectOrAddCertificateHolder: "Please Select or Add Certificate Holder",
      additionalInsuredsLossPayees:
        "Additional Insureds / Loss Payees to be included",
      selectAdditionalInsuredOrLossPayee:
        "Select Additional Insured/ Loss Payee",
      selectCoveragesAndLimits: "Select Coverages and Limits to Include",
      filterCoversByType: "Filter Covers by their type:",
      specifyOtherCoverages: "Specify Other Coverages",
      nameOfCoverage: "Name of coverage",
      limitProvided: "Limit Provided",
      deductible: "Deductible (where relevant)",
      delete: "Delete",
      createCertificate: "Create Certificate",
      updateCertificate: "Update Certificate",
      createCertificateAndDownloadEmail:
        "Create Certificate and download Email",
      updateCertificateAndDownloadEmail:
        "Update Certificate and download Email",
    },
  },
  fr: {
    certificate: {
      customizeCertificateHeading: "Personnalisez votre certificat",
      customizeCertificateSubHeading:
        "À partir d'ici, vous pouvez personnaliser les détails de votre certificat.",
      clientInformation: "Information sur le client potentiel​",
      clientName: "Nom du client",
      addressLine1: "Adresse Ligne 1",
      addressLine2: "Adresse Ligne 2",
      townCity: "Ville/Commune",
      province: "Province",
      postalCode: "Code Postal",
      country: "Pays",
      descriptionOfOperations:
        "Description des opérations, des emplacements ou des conditions spéciales",
      certificateHolderInformation:
        "Informations sur le titulaire du certificat",
      addNew: "Ajouter Nouveau",
      selectOrAddCertificateHolder:
        "Veuillez sélectionner ou ajouter un titulaire de certificat",
      additionalInsuredsLossPayees:
        "Assurés supplémentaires / Bénéficiaires de perte à inclure",
      selectAdditionalInsuredOrLossPayee:
        "Sélectionner un Assuré Supplémentaire/ Bénéficiaire de Perte",
      selectCoveragesAndLimits:
        "Sélectionnez les garanties et les limites à inclure",
      filterCoversByType: "Filtrer les couvertures par leur type:",
      specifyOtherCoverages: "Préciser d'autres couvertures",
      nameOfCoverage: "Nom de la couverture",
      limitProvided: "Limite Fourni",
      deductible: "Franchise (le cas échéant)",
      delete: "Supprimer",
      createCertificate: "Créer un certificat",
      updateCertificate: "Mettre à jour le certificat",
      createCertificateAndDownloadEmail:
        "Créer un certificat et télécharger l'email",
      updateCertificateAndDownloadEmail:
        "Mettre à jour le certificat et télécharger l'email",
    },
  },
};

const CertificateModal = (props) => {
  const policyCertificateId = props.binderFormData.binderdetails._id;
  const binderAddreses = useSelector(getSelectedBinderDetailLocationAddress);
  const clientDetails = useSelector(getCurrentClientDetails);
  const certificateDataObj = useSelector(getSingleCertificateList);
  const certificateDownload = useSelector(getDownloadedCertificate);
  const certificateHolderModalState = useSelector(
    getCertificateHolderModalState
  );
  const certificateHolderList = useSelector(getCertificateHolderListDetails);
  const allAdditional = useSelector(getCertificateHolderListDetails);
  const locationObjectvalue = useSelector(getLocationObjectValue);
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference || "en";
  const dispatch = useDispatch();
  const binderLocationsAddesses =
    binderAddreses && binderAddreses.state
      ? Object.keys(binderAddreses.state).map((addressId) => ({
          id: addressId,
          ...binderAddreses.state[addressId],
        }))
      : [];
  useEffect(() => {
    if (policyCertificateId) {
      dispatch(allCertificateHolderList(policyCertificateId));
    }
  }, [policyCertificateId]);
  const [coverinfo, setCoverInfo] = useState([]);
  const [allcovers, setAllCovers] = useState([]);
  const [covers, setCovers] = useState({});
  const [coversasis, setAllCoversasis] = useState({});
  const [allCoverValue, setAllCoverValue] = useState({});
  const [locationValueObj, setLocationValueObj] = useState({});
  const [locationObjForCheck, setLocationObjForCheck] = useState(
    certificateDataObj?.data?.locationsIds
  );
  const [checkedLocationValues, setCheckedLocationValues] = useState({});
  const [coverTypes, setCoverTypes] = useState("RESPONSE");
  const [binderLetter, setBinderLetter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [clientInformation, setClientInformation] = useState([]);
  const [errorHolder, setErrorHolder] = useState("");
  const [check, setCheck] = useState(false);
  const [otherCoveragesError, setOtherCoveragesError] = useState([]);
  const [errorMessageFlag, setErrorMessageFlag] = useState(false);
  const [locationDefaultObject, setLocationDefaultObject] = useState({});
  const [certificateLocationObject, setCertificateLocationObject] = useState(
    {}
  );
  const [indexes, setIndexes] = useState([]);
  const [isErrorOccured, setIsErrorOccured] = useState(false);
  const [filteredCoverTypes, setFilteredCoverTypes] = useState([]);
  const [certificateHolderName, setCertificateHolderName] = useState(null);
  const [storeBinder, setStoreBinder] = useState({
    policyid: "",
    clientName: "",
    covers: "",
    locationCovers: "",
    country: "",
    postalcode: "",
    province: "",
    street: "",
    streetNumber: "",
    town: "",
    comment: "",
    certificateHolderId: "",
    additionalInsurerId: [],
  });
  const othercoveragesData = {
    coverageName: "",
    limitProvided: "",
    deductible: "",
  };
  let [otherCoverages, setOtherCoverages] = useState([]);
  const getOtherList = () => {
    return [...otherCoverages];
  };
  const setOtherDetailsList = (list) => {
    setOtherCoverages(list);
  };
  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );
  const binderLetterStatus = useSelector(getBinderLetterStatus);
  const prospectidEncryCRS = useSelector(getEncryCRSProspectIdFromMyBinders());
  const storeBinderDetails = async (params) => {
    const storeBinderDetails = { ...storeBinder };
    const selectedList = [];
    selectedItems.forEach((m) => {
      selectedList.push(Object.values(m));
    });
    storeBinderDetails.policyid = props.binderFormData.binderdetails._id;
    storeBinderDetails.covers = Object.fromEntries(selectedList);
    storeBinderDetails.locationCovers = checkedLocationValues;
    const certificateData = {
      policyId: storeBinderDetails.policyid,
      coverId: storeBinderDetails.covers,
      locationsIds:
        certificateDataObj?.copyData === 1
          ? locationObjForCheck
          : storeBinderDetails.locationCovers,
      certificateHolderId: storeBinderDetails.certificateHolderId,
      additionalInsurerId: storeBinderDetails.additionalInsurerId
        ? storeBinderDetails.additionalInsurerId
        : null,
      clientName: storeBinderDetails.clientName,
      Address: {
        addressLine1: storeBinderDetails.street,
        addressLine2: storeBinderDetails.streetNumber,
        country: storeBinderDetails.country,
        city: storeBinderDetails.town,
        postalCode: storeBinderDetails.postalcode,
        province: storeBinderDetails.province,
      },
      otherCoverages: otherCoverages,
      coveragesCheckBox: check,
      comment: storeBinderDetails.comment,
    };
    const certificateDataUpdate = {
      _id: certificateDataObj.data?._id ? certificateDataObj.data?._id : null,
      policyId: storeBinderDetails.policyid,
      coverId: storeBinderDetails.covers,
      locationsIds: locationObjForCheck,
      certificateHolderId: storeBinderDetails.certificateHolderId,
      additionalInsurerId: storeBinderDetails.additionalInsurerId
        ? storeBinderDetails.additionalInsurerId
        : null,
      clientName: storeBinderDetails.clientName,
      Address: {
        addressLine1: storeBinderDetails.street,
        addressLine2: storeBinderDetails.streetNumber,
        country: storeBinderDetails.country,
        city: storeBinderDetails.town,
        postalCode: storeBinderDetails.postalcode,
        province: storeBinderDetails.province,
      },
      otherCoverages: otherCoverages,
      coveragesCheckBox: check,
      comment: storeBinderDetails.comment,
    };
    let isErrorOccured = false;
    if (!storeBinderDetails.certificateHolderId) {
      isErrorOccured = true;
      setErrorHolder("Please Select Certificate Holder");
    } else if (check === true) {
      const defaultArray = [];
      otherCoverages?.map((item, i) => {
        if (item.coverageName === "") defaultArray.push(i);
      });
      setOtherCoveragesError(defaultArray);
      if (defaultArray.length > 0) {
        isErrorOccured = true;
      }
    }
    if (!isErrorOccured) {
      const response = await fetch(
        `${process.env.REACT_APP_BASICSERVICE}/api/certificate/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": localStorage.getItem("jwt"),
          },
          body: JSON.stringify(
            certificateDataObj?.copyData === 3
              ? certificateDataUpdate
              : certificateDataObj?.copyData === 1
              ? certificateData
              : certificateData
          ),
        }
      );
      const putData = await response.json();
      const binderId = window.location.href.split("=").slice(-1)[0];
      if (response.ok) {
        toast.success(externalTranslations[languagecode].certificateCreated);
       await dispatch(certificateModalClosed());
       await dispatch(certificateDataClear());
       await dispatch(allCertificateDetails(binderId));
        
        toast.success(externalTranslations[languagecode].certificateDownloading);
        const pdfLanguagePrefIsFrench =
          localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
        dispatch(
          downloadCertificate(
            putData.certificateId,
            params,
            certificateHolderName,
            pdfLanguagePrefIsFrench ? "fr" : "en"
          )
        );
      } else {
        toast.error(
          certificateDataObj?.data?._id
            ? "Error Certificate Not Updated"
            : "Error Certificate Not Created"
        );
      }
    }
  };
  useEffect(() => {
    const temp = { ...storeBinder };
    const data = certificateDataObj?.data?._id
      ? { ...certificateDataObj }
      : props.binderFormData?.binderdetails;
    const clientAddress = clientDetails["CLIENT_ADDRESS"];
    temp.clientName =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.clientName
        : null || certificateDataObj?.copyData === 3
        ? data.data.clientName
        : null || data.CLIENT_NAME;
    temp.country =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.country
        : null || certificateDataObj?.copyData === 3
        ? data.data.address?.country
        : null || clientAddress.country;

    temp.postalcode =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.postalCode
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.address?.postalCode
        : null || clientAddress.postalcode;
    temp.province =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.province
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.address?.province
        : null || clientAddress.province;
    temp.street =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.addressLine1
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.address?.addressLine1
        : null || clientAddress.street;
    temp.streetNumber =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.addressLine2
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.address?.addressLine2
        : null || clientAddress.streetNumber;
    temp.town =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.address?.city
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.address?.city
        : null || clientAddress.town;
    temp.comment =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.comment
        : null || certificateDataObj?.copyData === 3
        ? data?.data?.comment
        : null;
    temp.certificateHolderId =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.certificataHolder
        : "" || certificateDataObj?.copyData === 3
        ? certificateDataObj?.data?.certificateHolderDetails?._id
        : "";
    temp.additionalInsurerId =
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.additionalInsured
        : "" || certificateDataObj?.copyData === 3
        ? certificateDataObj?.data?.additionalInsured
        : "";
    setStoreBinder(temp);
    setAllCoverValue(
      certificateDataObj?.copyData === 1
        ? {
            ...props.binderFormData.binderdetails.covers,
            ...certificateDataObj?.data?.cover,
          }
        : {} || certificateDataObj?.copyData === 3
        ? {
            ...props.binderFormData.binderdetails.covers,
            ...certificateDataObj?.data?.cover,
          }
        : props && props.binderFormData.binderdetails.covers
    );
    setAllCoversasis(
      certificateDataObj?.copyData === 1
        ? {
            ...props.binderFormData.binderdetails.coversasis,
            ...certificateDataObj?.data?.cover,
          }
        : {} || certificateDataObj?.copyData === 3
        ? {
            ...props.binderFormData.binderdetails.coversasis,
            ...certificateDataObj?.data?.cover,
          }
        : props && props.binderFormData.binderdetails.coversasis
    );
    if (
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.cover
        : null || certificateDataObj?.copyData === 3
        ? certificateDataObj?.data?.cover
        : props?.binderFormData?.binderdetails?.policySelectedResponse?.covers
    ) {
      const selectedCoversData =
        certificateDataObj?.copyData === 1
          ? certificateDataObj?.data?.cover
          : null || certificateDataObj?.copyData === 3
          ? certificateDataObj?.data?.cover
          : props.binderFormData.binderdetails.policySelectedResponse?.covers;
      const selectedItemList = [];
      Object.keys(selectedCoversData).map((value) => {
        selectedItemList.push({
          key: value,
          value: selectedCoversData[value],
        });
      });
      if (
        certificateDataObj?.copyData === 1 ||
        certificateDataObj?.copyData === 3
      ) {
        setSelectedItems(selectedItemList);
      }
    }
    if (
      certificateDataObj?.copyData === 1
        ? certificateDataObj?.data?.locationsIds
        : null || certificateDataObj?.copyData === 3
        ? certificateDataObj?.data?.locationsIds
        : props?.binderFormData?.binderdetails?.policySelectedResponse
            ?.locations
    ) {
      const selectedLocationData =
        certificateDataObj?.copyData === 1
          ? certificateDataObj?.data?.locationsIds
          : null || certificateDataObj?.copyData === 3
          ? certificateDataObj?.data?.locationsIds
          : props.binderFormData.binderdetails?.policySelectedResponse
              ?.locations;
      if (
        certificateDataObj?.copyData === 1 ||
        certificateDataObj?.copyData === 3
      ) {
        setCheckedLocationValues(selectedLocationData);
      }
    }
  }, []);
  useEffect(() => {
    let obj = props && props?.binderFormData?.binderdetails?.locations;
    const newObj = {};
    if (
      (certificateDataObj?.copyData === 1 &&
        certificateDataObj?.data?.locationsIds) ||
      (certificateDataObj?.copyData === 3 &&
        certificateDataObj?.data?.locationsIds)
    ) {
      Object.keys(obj)?.map((key, indexe) => {
        const temp = { ...obj[key] };
        newObj[key] = {
          ...temp,
          ...certificateDataObj?.data?.locationsIds[key],
        };
      });
    }
    if (
      (certificateDataObj?.copyData === 1 &&
        certificateDataObj?.data?.locationsIds) ||
      (certificateDataObj?.copyData === 3 &&
        certificateDataObj?.data?.locationsIds)
    ) {
      setLocationValueObj(newObj);
    } else {
      setLocationValueObj(obj);
    }
  }, [props?.binderFormData?.binderdetails?.locations]);

  useEffect(() => {
    if (certificateDataObj.copyData === 1) {
      setOtherCoverages(certificateDataObj.data.otherCoverages);
    } else if (certificateDataObj.copyData === 3) {
      setOtherCoverages(certificateDataObj.data.otherCoverages);
    } else {
      setOtherCoverages([{ ...othercoveragesData }]);
    }
  }, []);
  useEffect(() => {
    if (certificateDataObj.copyData === 1 || certificateDataObj.copyData === 3)
      setCertificateHolderName(
        certificateDataObj.data.certificateHolderDetails.interestname
      );
  }, []);

  useEffect(() => {
    //perents child combination code here..
    const certificateCovers =
      props && props?.binderFormData?.binderdetails?.allcovers;
    const covers = processCoversData(certificateCovers);
    setAllCovers(covers);
    setCoverInfo(props && props.binderFormData.binderdetails.covertypes);
  }, [props?.binderFormData]);
  useEffect(() => {
    if (
      (certificateDataObj?.copyData === 1 ||
        certificateDataObj?.copyData === 3) &&
      locationObjForCheck &&
      Object.keys(locationObjForCheck).length > 0
    ) {
      const locObject = {};
      const location = Object.values(locationObjForCheck);
      const binderAddresses = binderLocationsAddesses || []; // Assign an empty array as a fallback

      binderAddresses.forEach((item, index) => {
        locObject[item.id] = [];

        if (location && location[index]) {
          const dataObj = Object.keys(location[index]).map((val, i) =>
            locObject[item.id].push({ key: val })
          );
        }
      });

      setLocationDefaultObject(locObject);
    }
  }, [
    locationObjForCheck,
    certificateDataObj?.copyData === 1,
    certificateDataObj?.copyData === 3,
  ]);

  const defaultSelectedCheckedValue = (
    id,
    locationId,
    buildingId,
    isBuilding
  ) => {
    // for create certificate location default logic
    if (
      certificateDataObj?.copyData === undefined &&
      coverTypes === "LOCATION" &&
      certificateLocationObject
    ) {
      if (certificateLocationObject[locationId] && !isBuilding) {
        let createDefault = certificateLocationObject[locationId].filter(
          (item) => item.key == id
        );
        return createDefault.length > 0;
      } else {
        // Using lodash to safely access the nested id
        let selectedByDefault = _.get(checkedLocationValues, [
          locationId,
          "buildings",
          buildingId,
          id,
        ]);
        // Return true if the id exists, false otherwise
        return selectedByDefault !== undefined;
      }
    }

    if (
      (certificateDataObj?.copyData === 1 && locationId) ||
      (certificateDataObj?.copyData === 3 && locationId)
    ) {
      let locSelected = locationDefaultObject?.[locationId]?.filter(
        (item) => item.key == id
      );
      return locSelected?.length > 0;
    }
    let selected = selectedItems.filter((item) => item.key == id);
    return selected.length > 0;
  };

  const handleChecked = (
    checkbox,
    id,
    location,
    buildingData = {},
    isBuilding = false,
    buildingIndex
  ) => {
    const isSelected = selectedItems
      .map((item) => {
        if (item.key === id.toString()) {
          return id.toString();
        }
      })
      .indexOf(id.toString());
    const checkedLocation = { ...checkedLocationValues };
    const uncheckedLocationEdit = { ...locationValueObj };
    if (checkbox.target.checked) {
      // for update or copy location checkbox selection logic
      if (
        (location &&
          certificateDataObj.copyData === 3 &&
          coverTypes === "LOCATION") ||
        (location &&
          certificateDataObj.copyData === 1 &&
          coverTypes === "LOCATION")
      ) {
        const getLocationUpdatedObj = locationObjForCheck;
        const checkedLocationEdit = { ...getLocationUpdatedObj };
        let idObj = checkbox.target.value;
        if (checkedLocationEdit[location.id] === undefined) {
          checkedLocationEdit[location.id] = {};
        }
        checkedLocationEdit[location.id] = checkedLocationEdit[location.id] = {
          ...checkedLocationEdit[location.id],
          [idObj]: locationValueObj[location.id][idObj],
        };
        setLocationObjForCheck({ ...checkedLocationEdit });
      }
      //for create certificate location checkbox selection logic
      // if (
      //   location &&
      //   locationValueObj &&
      //   coverTypes === "LOCATION" &&
      //   certificateDataObj.copyData === undefined
      // ) {
      //   const id = checkbox.target.value;
      //   if (checkedLocation[location.id] === undefined) {
      //     checkedLocation[location.id] = {};
      //   }
      //   checkedLocation[location.id][checkbox.target.value] =
      //     locationValueObj[location.id][checkbox.target.value];
      //   setCheckedLocationValues(checkedLocation);
      //   if (checkedLocationValues) {
      //     const locObject = {};
      //     const location = Object.values(checkedLocationValues);
      //     if (location.length > 0) {
      //       let data = binderLocationsAddesses?.map((item, index) => {
      //         locObject[item.id] = [];
      //         if (location?.[index]) {
      //           const dataObj = Object.keys(location?.[index])?.map((val, i) =>
      //             locObject[item.id].push({ key: val })
      //           );
      //         }
      //       });
      //       setCertificateLocationObject(locObject);
      //     }
      //   }
      // }

      if (
        location &&
        coverTypes === "LOCATION" &&
        checkbox.target.value &&
        certificateDataObj.copyData === undefined
      ) {
        if (isBuilding) {
          const id = checkbox.target.value;

          if (checkedLocation[location.id] === undefined) {
            checkedLocation[location.id] = {};
            checkedLocation[location.id].buildings = {};
          }

          if (
            checkedLocation[location.id].buildings[buildingIndex] === undefined
          ) {
            checkedLocation[location.id].buildings[buildingIndex] = {};
          }
          checkedLocation[location.id].buildings[buildingIndex][
            checkbox.target.value
          ] =
            locationValueObj[location.id].buildings[buildingIndex][
              checkbox.target.value
            ];

          setCheckedLocationValues(checkedLocation);

          if (checkedLocationValues) {
            const locObject = {};

            // Use the locationId and buildingIndex that are passed to the function
            const locationData = checkedLocationValues[location.id];
            if (
              locationData &&
              locationData.buildings &&
              locationData.buildings[buildingIndex]
            ) {
              const buildingKey = `${location.id}_building_${buildingIndex}`;
              locObject[buildingKey] = Object.keys(
                locationData.buildings[buildingIndex]
              ).map((key) => ({ key: key }));
            }

            setCertificateLocationObject(locObject);
          }
        } else {
          const id = checkbox.target.value;
          if (checkedLocation[location.id] === undefined) {
            checkedLocation[location.id] = {};
          }
          checkedLocation[location.id][checkbox.target.value] =
            locationValueObj[location.id][checkbox.target.value];
          setCheckedLocationValues(checkedLocation);

          if (checkedLocationValues) {
            const locObject = {};
            const location = Object.values(checkedLocationValues);
            if (location.length > 0) {
              let data = binderLocationsAddesses?.map((item, index) => {
                locObject[item.id] = [];
                if (location?.[index]) {
                  const dataObj = Object.keys(location?.[index])?.map(
                    (val, i) => locObject[item.id].push({ key: val })
                  );
                }
              });
              setCertificateLocationObject(locObject);
            }
          }
        }
      }
      // for other covers not for location covers check
      if (coverTypes != "LOCATION") {
        if (allCoverValue != null) {
          var temppSelectedItems = selectedItems;
          selectedItems.push({
            key: id.toString(),
            value: allCoverValue[id].toString(),
          });
          // setSelectedItems(temppSelectedItems);
        } else {
          var temppSelectedItems = selectedItems;
          selectedItems.push({
            key: id.toString(),
            value: coversasis[id].toString(),
          });
          // setSelectedItems(temppSelectedItems);
        }
      }
    } else {
      if (
        (location &&
          certificateDataObj.copyData === 3 &&
          coverTypes === "LOCATION") ||
        (location &&
          certificateDataObj.copyData === 1 &&
          coverTypes === "LOCATION")
      ) {
        //delete location object when uncheck in edit or copy modal
        const getLocationUpdatedObj = locationObjForCheck;
        const checkedLocationEdit = { ...getLocationUpdatedObj };
        let idObj = checkbox.target.value;
        checkedLocationEdit[location.id] = {
          ...checkedLocationEdit[location.id],
          [idObj]: false,
        };
        delete checkedLocationEdit[location?.id][idObj];
        setLocationObjForCheck({ ...checkedLocationEdit });
        if (Object.keys(checkedLocationEdit[location?.id]).length === 0) {
          delete checkedLocationEdit[location.id];
        }
      }
      if (
        certificateDataObj.copyData === undefined &&
        coverTypes === "LOCATION" &&
        location
      ) {
        if (checkedLocation[location.id] && checkedLocation[location.id][id]) {
          //delete location object when uncheck
          delete checkedLocation[location.id][id.toString()];
          setCheckedLocationValues(checkedLocation);
        }
      }
      if (coverTypes != "LOCATION") selectedItems.splice(isSelected, 1);
    }
  };
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  const getCoversasisValue = (id, inputvaluetype, locationId, buildingKey) => {
    let returnValue = "";
    let covers;
    if (
      buildingKey &&
      locationValueObj[locationId] &&
      locationValueObj[locationId].buildings[buildingKey]
    ) {
      covers = locationValueObj[locationId].buildings[buildingKey];
    } else {
      covers =
        (locationValueObj && locationId >= 0 && locationValueObj[locationId]) ||
        allCoverValue ||
        coversasis;
    }
    let coversasisvalue = (covers && covers[id]) || " ";
    if (!coversasisvalue) return null;
    if (id === getCoverIdForExpiryDate()) {
      returnValue =
        coversasisvalue &&
        moment(new Date(coversasisvalue)).format("DD MMM YYYY");
    } else if (isNaN(parseInt(coversasisvalue))) {
      returnValue = coversasisvalue + "";
    } else {
      if (
        (inputvaluetype === "percent2f" || isDecimal(coversasisvalue)) && // If a user is passing a decimal to be converted into percentage we it may not have the label of percent, so we need to check if its a decimal and let the further logic check if it needs to be a percentage or not
        coversasisvalue > 0 &&
        coversasisvalue <= 1.1
      ) {
        returnValue = coversasisvalue * 100 + "%";
      } else {
        returnValue = formatter.format(coversasisvalue);
      }
    }
    return returnValue;
  };

  useEffect(() => {
    setFilteredCoverTypes(
      allcovers?.filter((coverItem) => coverItem.covertypecode === coverTypes)
    );
  }, [coverTypes, allcovers]);
  const handleCoverChange = (event, id, location, buildingIndex) => {
    let returnValue = "";
    // Create a copy of the locationValueObj state variable using spread syntax
    if (location) {
      let newLocationValueObj = _.cloneDeep(locationValueObj);
      if (buildingIndex !== undefined) {
        newLocationValueObj[location.id].buildings[buildingIndex] = {
          ...newLocationValueObj[location.id].buildings[buildingIndex],
          [id]: event.target.value,
        };
      } else {
        newLocationValueObj[location.id] = {
          ...newLocationValueObj[location.id],
          [id]: event.target.value,
        };
      }
      setLocationValueObj(newLocationValueObj);
    } else {
      let coversasisvalue = { ...coversasis };
      coversasisvalue[id] = event.target.value;
      setAllCoversasis(coversasisvalue);
      let allCoversValue = { ...allCoverValue };
      allCoversValue[id] = event.target.value;
      setAllCoverValue(allCoversValue);

      if (event.target.value) {
        selectedItems.push({
          key: id.toString(),
          value: event.target.value.toString(),
        });
      }
    }
  };
  const style = {
    minHeight: "2vh",
    fontSize: "1.8vmin",
    fontFamily: "GibsonRegular",
  };
  const inputStyle = {
    marginLeft: "-57%",
    borderRadius: "10px",
    border: "0px",
    width: "163%",
    lineHeight: "39px",
    marginBottom: "14px",
    marginTop: "-4px",
    padding: "0 10px",
  };

  const handleCloseButton = () => {
    dispatch(certificateDataClear());
    dispatch(certificateModalClosed());
  };
  const classes = useStyles();
  const heights = {
    desc: "8%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };
  const hDist = {
    headingHeight: "10%",
    remainingHeight: "10%",
  };
  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;
  heights.remainingHeight = `calc(100% - ${heights.desc} - ${heights.proceedbutton} - ${heights.somegapbetween})`;
  const handleCertificateHolder = (event) => {
    const temp = { ...storeBinder };
    temp.holderName = event.target.value;
    temp.policyid = props.binderId;
    setStoreBinder(temp);
  };
  const handleAddClick = () => {
    setOtherCoverages([...otherCoverages, { ...othercoveragesData }]);
  };
  const handleOtherCoveragesRemove = (i) => {
    const list = [...otherCoverages];
    list.splice(i, 1);
    setOtherCoverages(list);
  };
  const onAdditionalOpenHandler = () => {
    dispatch(certificateFalg({ data: 0 }));
    dispatch(certificateModalClosed());
    dispatch(additionalModalOpened());
  };
  const certificateHolder = () => {
    dispatch(certificateHolderModalOpened());
  };
  const handleClientNameChange = (event) => {
    const temp = { ...storeBinder };
    temp.clientName = event.target.value;
    setStoreBinder(temp);
  };
  useEffect(() => {
    if (certificateDataObj?.data?.coveragesCheckBox === true) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  }, [certificateDataObj?.data?.coveragesCheckBox]);
  const findNameById = (id) => {
    const foundItem = certificateHolderList.find((item) => item._id === id);
    if (foundItem) {
      return foundItem.interestname;
    } else {
      return "Unknown"; // Return a default value if ID is not found
    }
  };
  const locationsData = props?.binderFormData?.binderdetails?.locations;
  const hasBuilding = _.some(locationsData, (location) => {
    return _.some(location, (value, key) => key.includes("buildings"));
  });

  const buildingsData = hasBuilding ? locationsData : null;
  return (
    <>
      <Modal
        isOpen={certificateHolderModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
            color: "white",
          },
          content: {
            height: "98vh",
            width: "60vw",
            position: "absolute",
            top: "1vh",
            left: "20vw",
            right: 0,
            bottom: 0,
            background: "white",
            WebkitOverflowScrolling: "touch",
            border: `8px solid white`,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddCertificateHolder
          binderFormData={props.binderFormData}
          binderId={props.binderId}
        />
      </Modal>
      <CommonModalForConfiguration
        heading={
          translations[languagecode]?.certificate.customizeCertificateHeading
        }
        subHeading={
          translations[languagecode]?.certificate.customizeCertificateSubHeading
        }
        handleCloseButton={handleCloseButton}
        classes={classes}
        heights={heights}
        hDist={hDist}
        storeBinderDetails={storeBinderDetails}
        binderLetterStatus={binderLetterStatus}
        binderdetails={props.binderFormData.binderdetails}
      >
        <CommonHeading
          text={translations[languagecode]?.certificate.clientInformation}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.clientName}
          placeholder={translations[languagecode]?.certificate.clientName}
          onChange={handleClientNameChange}
          value={storeBinder ? storeBinder.clientName : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.addressLine1}
          placeholder={translations[languagecode]?.certificate.addressLine1}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.streetNumber = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.streetNumber : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.addressLine2}
          placeholder={translations[languagecode]?.certificate.addressLine2}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.street = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.street : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.townCity}
          placeholder={translations[languagecode]?.certificate.townCity}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.town = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.town : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.province}
          placeholder={translations[languagecode]?.certificate.province}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.province = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.province : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.postalCode}
          placeholder={translations[languagecode]?.certificate.postalCode}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.postalcode = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.postalcode : null}
        />
        <CommonInputField
          label={translations[languagecode]?.certificate.country}
          placeholder={translations[languagecode]?.certificate.country}
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.country = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.country : null}
        />
        <div className="mt-4">
          <CommonHeading
            text={
              translations[languagecode]?.certificate.descriptionOfOperations
            }
          />
        </div>
        <CommonTextBoxField
          placeholder={
            translations[languagecode]?.certificate.commentsPlaceholder
          }
          onChange={(event) => {
            const temp = { ...storeBinder };
            temp.comment = event.target.value;
            setStoreBinder(temp);
          }}
          value={storeBinder ? storeBinder.comment : null}
        />
        <div className="mt-4"></div>
        <CommonHeading
          text={
            translations[languagecode]?.certificate.certificateHolderInformation
          }
        />

        <Button
          style={{
            color: "white",
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            backgroundColor: theme.COLORS.secondary_skyblue,
            border: 0,
            display: "flex",
            float: "right",
            marginRight: "20px",
            marginTop: "10px",
            marginBottom: "-62px",
          }}
          onClick={() => {
            certificateHolder();
          }}
        >
          {translations[languagecode]?.certificate.addNew}
        </Button>
        <section
          style={{
            paddingRight: "7vmin",
            paddingLeft: "7vmin",
          }}
        >
          <select
            name={
              translations[languagecode]?.certificate
                .selectOrAddCertificateHolder
            }
            style={{
              borderRadius: "10px",
              border: "0px",
              width: "80%",
              height: "7vmin",
              paddingLeft: "2vmin",
              paddingRight: "2vmin",
              backgroundColor: theme.COLORS.tertiary_ligthindigo,
            }}
            onChange={(event) => {
              const holdername = findNameById(event.target.value);
              setCertificateHolderName(holdername);
              setErrorHolder("");
              const temp = { ...storeBinder };
              temp.certificateHolderId = event.target.value;
              setStoreBinder(temp);
            }}
            aria-label="Default select example"
            required
          >
            {certificateHolderList ? (
              <option disabled selected>
                {
                  translations[languagecode]?.certificate
                    .selectOrAddCertificateHolder
                }
              </option>
            ) : null}
            {certificateHolderList &&
              certificateHolderList.map((item, i) => {
                return (
                  <option
                    key={i}
                    value={item && item._id}
                    style={{ height: "3vh" }}
                    selected={
                      certificateDataObj?.data?.certificataHolder == item._id
                    }
                  >
                    {item && item.interestname}
                  </option>
                );
              })}
          </select>
        </section>
        <small
          style={{
            color: "red",
            marginLeft: "5%",
          }}
        >
          {errorHolder}
        </small>
        <div className="mt-4"></div>
        <CommonHeading
          text={
            translations[languagecode]?.certificate.additionalInsuredsLossPayees
          }
        ></CommonHeading>
        <Button
          style={{
            color: "white",
            fontFamily: "GibsonSemiBd",
            fontSize: 20,
            backgroundColor: theme.COLORS.secondary_skyblue,
            border: 0,
            display: "flex",
            float: "right",
            marginRight: "20px",
            marginTop: "10px",
            marginBottom: "-62px",
          }}
          onClick={() => {
            onAdditionalOpenHandler();
          }}
        >
          {translations[languagecode]?.certificate.addNew}
        </Button>

        <section
          style={{
            paddingRight: "7vmin",
            paddingLeft: "7vmin",
          }}
        >
          <Select
            style={{
              borderRadius: "10px",
              border: "0px",
              width: "80%",
              height: "7vmin",
              paddingLeft: "2vmin",
              paddingRight: "2vmin",
              backgroundColor: theme.COLORS.tertiary_ligthindigo,
            }}
            className="form-control"
            multi="true"
            keepSelectedInList="true"
            color="rgb(73, 168, 214)"
            placeholder={
              translations[languagecode]?.certificate
                .selectAdditionalInsuredOrLossPayee
            }
            options={
              allAdditional &&
              allAdditional
                .filter(
                  (item) =>
                    item.isAdditionalInsured === true ||
                    item.isLossPayee === true ||
                    (item.isAdditionalInsured === true &&
                      item.isLossPayee === true.includes(allAdditional))
                )
                .map((val) => {
                  return { value: val._id, label: val.interestname };
                })
            }
            values={
              allAdditional &&
              allAdditional
                .filter((item) =>
                  certificateDataObj.copyData === 1
                    ? certificateDataObj?.data?.additionalInsured?.includes(
                        item._id
                      )
                    : certificateDataObj.copyData === 3
                    ? certificateDataObj?.data?.additionalInsured?.includes(
                        item._id
                      )
                    : null
                )
                .map((val) => {
                  return { value: val._id, label: val.interestname };
                })
            }
            onChange={function (event) {
              const temp = { ...storeBinder };
              temp.additionalInsurerId = event.map((data) => data.value);
              setStoreBinder(temp);
            }}
          />
        </section>
        <div style={{ height: "2vh" }}></div>
        <CommonHeading
          text={
            translations[languagecode]?.certificate.selectCoveragesAndLimits
          }
        ></CommonHeading>
        <div style={{ height: "2vh" }}></div>
        <div style={{ paddingLeft: "7vmin" }}>
          {translations[languagecode]?.certificate.filterCoversByType}{" "}
        </div>
        <CoverTypeSelection
          setCoverTypes={setCoverTypes}
          coverinfo={coverinfo}
          allcovers={allcovers}
        ></CoverTypeSelection>
        <div style={{ height: "2vh" }}></div>
        <SelectedCertificateCoverByCoverType
          coverOfCoverType={filteredCoverTypes}
          locations={binderLocationsAddesses}
          coverTypes={coverTypes ? coverTypes : "RESPONSE"}
          getCoversasisValue={getCoversasisValue}
          handleCoverChange={handleCoverChange}
          handleChecked={handleChecked}
          storeBinder={storeBinder}
          defaultSelectedCheckedValue={defaultSelectedCheckedValue}
          buildings={buildingsData}
        />

        <div style={{ height: "5vh" }}></div>

        <div style={{ paddingLeft: "7vmin" }}>
          <div className="form-group row">
            <div className="col-sm-9 mb-1">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="defaultCheck1"
                  onChange={(event) => {
                    setCheck(event.target.checked);
                  }}
                  checked={check}
                />
                <label className="form-check-label " for="defaultCheck1">
                  <b>
                    {
                      translations[languagecode]?.certificate
                        .specifyOtherCoverages
                    }{" "}
                  </b>
                </label>
              </div>
            </div>
          </div>
        </div>
        {check ? (
          <div>
            <div
              className="d-flex justify-content-end"
              style={{ marginRight: "12%", marginBottom: "16px" }}
            >
              {otherCoverages && otherCoverages.length + 1 && (
                <Button
                  style={{
                    color: "white",
                    fontFamily: "GibsonSemiBd",
                    fontSize: 20,
                    backgroundColor: theme.COLORS.secondary_skyblue,
                    border: 0,
                    display: "flex",
                    marginRight: "-28px",
                  }}
                  onClick={handleAddClick}
                >
                  Add More
                </Button>
              )}
            </div>

            {otherCoverages &&
              otherCoverages.map((coverageItem, index) => {
                return (
                  <>
                    <div
                      className="card "
                      style={{
                        paddingLeft: "2vmin",
                        marginLeft: "8%",
                        marginRight: "8%",
                        backgroundColor: "rgb(63, 68, 90)",
                        marginBottom: "10px",
                        border: `2px solid ${theme.COLORS.white_Indo}`,
                        borderRadius: 5,
                      }}
                    >
                      <CommonOtherCoveragesInputField
                        label={
                          translations[languagecode]?.certificate.nameOfCoverage
                        }
                        placeholder={
                          translations[languagecode]?.certificate.nameOfCoverage
                        }
                        onChange={(event) => {
                          const list = JSON.parse(
                            JSON.stringify(getOtherList())
                          );
                          list[index].coverageName = event.target.value;
                          setOtherDetailsList(list);
                        }}
                        value={coverageItem ? coverageItem?.coverageName : null}
                      ></CommonOtherCoveragesInputField>
                      <small
                        style={{
                          color: "red",
                          marginLeft: "31%",
                        }}
                      >
                        {otherCoveragesError.indexOf(index) !== -1
                          ? "This field is required"
                          : ""}
                      </small>
                      <div
                        className="form-group"
                        style={{ position: "absolute", top: 14, right: 14 }}
                      >
                        {otherCoverages && otherCoverages?.length !== 1 && (
                          <button
                            className="btn"
                            style={{
                              backgroundColor: "#d13010",
                              color: "white",
                              fontSize: 20,
                            }}
                            onClick={() => {
                              handleOtherCoveragesRemove(index);
                            }}
                          >
                            Delete
                          </button>
                        )}
                      </div>
                      <div>
                        <CommonOtherCoveragesInputField
                          label={
                            translations[languagecode]?.certificate
                              .limitProvided
                          }
                          placeholder={
                            translations[languagecode]?.certificate
                              .limitProvided
                          }
                          onChange={(event) => {
                            const list = JSON.parse(
                              JSON.stringify(getOtherList())
                            );
                            list[index].limitProvided = event.target.value;
                            setOtherDetailsList(list);
                          }}
                          value={
                            coverageItem ? coverageItem?.limitProvided : null
                          }
                        ></CommonOtherCoveragesInputField>
                        <CommonOtherCoveragesInputField
                          label={
                            translations[languagecode]?.certificate.deductible
                          }
                          placeholder={
                            translations[languagecode]?.certificate.deductible
                          }
                          onChange={(event) => {
                            const list = JSON.parse(
                              JSON.stringify(getOtherList())
                            );
                            list[index].deductible = event.target.value;
                            setOtherDetailsList(list);
                          }}
                          value={coverageItem ? coverageItem?.deductible : null}
                        ></CommonOtherCoveragesInputField>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        ) : null}
      </CommonModalForConfiguration>
    </>
  );
};

const CommonHeading = ({ text }) => {
  return (
    <section
      style={{
        width: "100%",
        height: "4vh",
        fontSize: "2.2vmin",
        color: theme.COLORS.secondary_skyblue,
        display: "flex",
        alignItems: "center",
      }}
    >
      {text}
    </section>
  );
};
const CommonInput = ({
  label = "Sample label",
  onChange,
  value,
  placeholder,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <textarea
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></textarea>
      </div>
    </section>
  );
};
const CommonInputField = ({
  label = "Sample common label",
  onChange,
  value,
  defaultValue,
  placeholder,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <input
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          placeholder={placeholder}
        ></input>
      </div>
    </section>
  );
};
const CommonOtherCoveragesInputField = ({
  label = "Sample common label",
  onChange,
  value,
  defaultValue,
  placeholder,
  required,
}) => {
  return (
    <section
      style={{
        minHeight: "8vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "2vh",
        marginBottom: "7px",
      }}
    >
      <div
        style={{
          width: "30%",
          paddingLeft: "7vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {label}
      </div>
      <div style={{ width: "50%", minHeight: "100%" }}>
        <input
          style={{
            width: "100%",
            height: "100%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
        ></input>
      </div>
    </section>
  );
};

const CommonModalForConfiguration = ({
  heading,
  subHeading,
  handleCloseButton,
  classes,
  heights,
  hDist,
  children,
  storeBinderDetails,
  binderLetterStatus,
  binderdetails,
}) => {
  const dispatch = useDispatch();
  const certificateData = useSelector(getSingleCertificateList);
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference || "en";
  const [isModalOpen,setIsModalOpen]=useState(false)

  const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
  const languagepreference = pdfLanguagePrefIsFrench ? "fr" : "en"

  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(certificateModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);
  return (<>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          height: hDist.headingHeight,
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.secondary_skyblue,
            fontSize: "1.9vmin",
            letterSpacing: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          {heading}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist.remainingHeight,
          backgroundColor: theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={handleCloseButton}
          ></CancelIcon>
        </div>

        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          <div
            style={{
              width: "100%",
              height: heights.desc,
              fontSize: "1.7vmin",
              letterSpacing: 1,
              fontFamily: "GibsonLight",
              padding: "2vmin",
              paddingLeft: 0,
            }}
          >
            {subHeading}
          </div>

          <div
            style={{
              width: "100%",
              height: heights.remainingHeight,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflowY: "auto",
              overflowX: "hidden",
            }}
            className={classes.responses}
          >
            {children}
          </div>
          <div
            style={{
              width: "100%",
              height: heights.somegapbetween,
            }}
          ></div>
          <div
            style={{
              width: "100%",
              display: "inline-flex",
              height: heights.proceedbutton,
            }}
          >
            {/* <div
              style={{
                width: "45%",
                marginLeft: "4%",
                marginRight: "1.5%",
                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              onClick={() => {
                storeBinderDetails();
              }}
            >
              {certificateData?.copyData === 3
                ? translations[languagecode]?.certificate.updateCertificate
                : translations[languagecode]?.certificate.createCertificate}
            </div>
            <div
              style={{
                width: "45%",

                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              onClick={() => {
                storeBinderDetails({
                  downloadingEml: true,
                  mailto: binderdetails.CLIENT_EMAIL,
                  bcc: "",
                  body: emailBodyCertificate[languagepreference].replaceAll(
                    "<<brokername>>",
                    binderdetails.brokername + " " // reason for extra space the replace all function removes last char for some reason, this is temp fix
                  ),
                  subject: "Your certificate",
                });
              }}
            >
              {certificateData?.copyData === 3
                ? translations[languagecode]?.certificate
                    .updateCertificateAndDownloadEmail
                : translations[languagecode]?.certificate
                    .createCertificateAndDownloadEmail}
            </div> */}
            <DropdownButton
              style={{
                width: "100%",
                marginLeft: "4%",
                marginRight: "1.5%",
                backgroundColor: theme.COLORS.secondary_orange,
                fontSize: "1.9vmin",
                letterSpacing: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 10,
                cursor: "Pointer",
              }}
              className="custom-dropdown-button-2"
              // variant="warning"
              title={externalTranslations[languagecode]?.certificateDownloadOptions}
              id="bg-nested-dropdown"
              // show={dropdownOpen}
              drop={"up"}
              // onToggle={handleDropdownToggle}
            >
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="0"
                onClick={() => {
                  // setuseEmail(false);
                  setIsModalOpen(true);
                }}
              >
                {externalTranslations[languagecode]?.editPDFOptions}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="1"
                onClick={() => {
                  // setuseEmail(false);
                  // setIsModalOpen(true);
                  storeBinderDetails();
                }}
              >
                 {certificateData?.copyData === 3
                ? translations[languagecode]?.certificate.updateCertificate
                : translations[languagecode]?.certificate.createCertificate}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="2"
                onClick={() => {
                  // setuseEmail(false);
                  storeBinderDetails({
                    downloadingEml: true,
                    mailto: binderdetails.CLIENT_EMAIL,
                    bcc: "",
                    body: emailBodyCertificate[languagepreference].replaceAll(
                      "<<brokername>>",
                      binderdetails.brokername + " " // reason for extra space the replace all function removes last char for some reason, this is temp fix
                    ),
                    subject: "Your certificate",
                  });
                }}
              >
               {certificateData?.copyData === 3
                ? translations[languagecode]?.certificate
                    .updateCertificateAndDownloadEmail
                : translations[languagecode]?.certificate
                    .createCertificateAndDownloadEmail}
              </Dropdown.Item>
            </DropdownButton>
          </div>
        </div>
      </div>
    </div>
    <PdfSettingsModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
const CoverTypeSelection = ({ setCoverTypes, coverinfo, allcovers }) => {
  const [selectedCoverTypes, setSelectedCoverTypes] = useState([]);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  const getFilteredCoverType = async (ids) => {
    const filteredCoverTypeCode = new Set();
    await allcovers?.map((item) => {
      if (ids.includes(item.id)) {
        filteredCoverTypeCode.add(item?.covertypecode);
      }
    });
    return [...filteredCoverTypeCode];
  };
  const coverTypesId = () => {
    return allcovers?.map((item) => {
      return item.id;
    });
  };
  useEffect(async () => {
    const coverIds = coverTypesId();
    const filterCoverTypes = await getFilteredCoverType(coverIds && coverIds);
    setSelectedCoverTypes(
      coverinfo.filter((item) => filterCoverTypes.includes(item?.code))
    );
  }, [coverinfo]);

  return (
    <section
      style={{
        paddingRight: "7vmin",
        paddingLeft: "7vmin",
      }}
    >
      <select
        name="Select Coverages"
        style={{
          borderRadius: "10px",
          border: "0px",
          width: "100%",
          height: "8vmin",
          paddingLeft: "2vmin",
          paddingRight: "2vmin",
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
          cursor: "pointer",
        }}
        onChange={(event) => {
          setCoverTypes(event.target.value);
        }}
      >
        {selectedCoverTypes &&
          selectedCoverTypes.map((item, i) => {
            return (
              <option
                key={i}
                value={item && item.code}
                style={{ height: "3vh" }}
              >
                {item && item.name[languagepreference]}
              </option>
            );
          })}
      </select>
    </section>
  );
};
const CommonTextBoxField = ({ onChange, value, placeholder }) => {
  return (
    <section
      style={{
        minHeight: "7vh",
        width: "100%",
        alignItems: "center",
        paddingTop: "2vh",
        paddingLeft: "7vh",
      }}
    >
      <div
        style={{
          width: "100%",
          paddingLeft: "2vmin",
          height: "100%",
          display: "flex",
          alignItems: "flex-start",
        }}
      ></div>
      <div style={{ width: "90%", minHeight: "100%" }}>
        <textarea
          style={{
            width: "100%",
            height: "100%",
            marginRight: "5%",
            padding: "2vmin",
            color: theme.COLORS.dark_navy_blue,
            border: `2px solid ${theme.COLORS.secondary_skyblue}`,
            borderRadius: 5,
            letterSpacing: 1.2,
            backgroundColor: theme.COLORS.tertiary_ligthindigo,
          }}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        ></textarea>
      </div>
    </section>
  );
};

export default CertificateModal;
